<!-- 查询线上月票类型接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {
                "monthTicketConfigId": 507
            },
            responseCode: {
                "data": {
                    "monthTicketConfigId": 11
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台查询线上月票类型详情",
                t_url: this.commonUrls.test + "getMonthTicketConfigDetail",
                p_url: this.commonUrls.prod + "getMonthTicketConfigDetail",
                precondition: "无",
                fitSystem: "云停车场,VEMS传统车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'monthTicketConfigId', info2: '是', info3: 'Long', info4: '月票类型ID' },
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'id', info2: '是', info3: 'Long', info4: '月票类型ID' },
                        { info1: 'ticketCode', info2: '是', info3: 'String', info4: '月票类型编号' },
                        { info1: 'ticketName', info2: '是', info3: 'String', info4: '月票类型名称' },
                        { info1: 'parkList', info2: '是', info3: 'JSONArray', info4: '适用车场信息' },
                        { info1: 'financialParkCode', info2: '是', info3: 'String', info4: '财务主体车场编号' },
                        { info1: 'channelArr', info2: '是', info3: 'JSONArray', info4: '适用车场通道信息' },
                        { info1: 'certifiRuleId', info2: '是', info3: 'Long', info4: '月票凭证ID' },
                        { info1: 'isOnlineOpen', info2: '是', info3: 'Integer', info4: '是否允许移动端开票 0：否 1：是' },
                        { info1: 'isOnlineRenew', info2: '是', info3: 'Integer', info4: '是否允许移动端续费 0：否 1：是' },
                        { info1: 'validTo', info2: '是', info3: 'Integer', info4: '有效期至 yyyyMMddHHmmss' },
                        { info1: 'ticketStatus', info2: '是', info3: 'Integer', info4: '月票状态 0：下架 1：上架' },
                        { info1: 'maxSellLimit', info2: '是', info3: 'Integer', info4: '最大销售数量限制，0无限，1有限' },
                        { info1: 'maxSellNum', info2: '是', info3: 'Integer', info4: '最大销售数量，maxSellLimit=1 有效' },
                        { info1: 'sellNum', info2: '是', info3: 'Integer', info4: '已销售数量' },
                        { info1: 'price', info2: '是', info3: 'Decimal', info4: '单价，单位：元' },
                        { info1: 'renewFormerDays', info2: '是', info3: 'Integer', info4: '允许车主购买该月票时，向前续费相应的天数。0表示不允许向前续费' },
                        { info1: 'supportVirtualCarcode', info2: '是', info3: 'Integer', info4: '支持无牌车 0：不支持 1：支持' },
                        { info1: 'inviteCarSwitcher', info2: '是', info3: 'Integer', info4: '访客授权 0：不支持 1：支持' },
                        { info1: 'inviteCarTotal', info2: '否', info3: 'Integer', info4: '允许授权访客车牌数' },
                        { info1: 'isDynamicMode', info2: '是', info3: 'Integer', info4: '是否多位多车（0否，1是）' },
                        { info1: 'autoSwitchVip', info2: '是', info3: 'Integer', info4: '是否自动切换多位多车场内临时车转vip(0否,1是)。' },
                        { info1: 'dynamicFullLimit', info2: '是', info3: 'Integer', info4: '是否多位多车满位，同组在场车无法进入（0否，1是）' },
                        { info1: 'openVipFullLimit', info2: '是', info3: 'Integer', info4: 'vip满位阈值' },
                        { info1: 'vipFullOpenModel', info2: '是', info3: 'Integer', info4: 'VIP满位放行模式 0:系统有空位自动放行，无空位手动放行按VIP计费 1:系统有空位自动放行，无空位手动放行按临时车计费 2:系统无空位自动放行，按临时车计费' },
                        { info1: 'isDatePrivilege', info2: '是', info3: 'Integer', info4: '月票生效的日期，是否区分日期（0不区分，1区分）' },
                        { info1: 'isTimePrivilege', info2: '是', info3: 'Integer', info4: '月票生效的时段，是否区分时间段（0不区分，1区分）' },
                        { info1: 'privilegedateList', info2: '是', info3: 'String', info4: 'VIP有效日期 格式：yyyy-MM-dd，使用‘,’分割。例：“2019-01-01,2019-01-02”' },
                        { info1: 'privilegeTimePeriod', info2: '是', info3: 'Integer', info4: 'VIP有权限时间段，isTimePrivilege=1时必传，格式mm:ss-mm:ss' },
                        { info1: 'isChargeGroupRelated', info2: '是', info3: 'Integer', info4: '是否关联收费组(0否,1是，默认为否)' },
                        { info1: 'chargeGroupCode', info2: '否', info3: 'String', info4: '收费组编号' },
                        { info1: 'renewMethod', info2: '是', info3: 'Integer', info4: '续费方式，对内月票才有，0自然月，1自定义（允许车主自定义选择续费时间，价格按照天数去计算。如月票单价300元，每天则为10元。）默认0' },
                        { info1: 'monthTicketContinueDiscountList', info2: '是', info3: 'JSONArray', info4: '连续续费优惠' },
                      ]
                },{
                    titleName: 'parkList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        ]
                },{
                    titleName: 'channelArr',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        { info1: 'channelId', info2: '是', info3: 'Long', info4: '通道ID' },
                        { info1: 'channelName', info2: '是', info3: 'String', info4: '通道名称' },
                        { info1: 'entranceType', info2: '是', info3: 'Integer', info4: '通道类型 1：进口 2：出口' },
                        ]
                },{
                    titleName: 'monthTicketContinueDiscountList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'id', info2: '是', info3: 'Long', info4: '连续续费优惠ID' },
                        { info1: 'continuDiscountType', info2: '是', info3: 'Integer', info4: '连续优惠类型,0:折扣优惠,1:金额优惠' },
                        { info1: 'continuMonth', info2: '是', info3: 'Integer', info4: '连续月份' },
                        { info1: 'discount', info2: '是', info3: 'Integer', info4: '折扣 1:1折 2：2折' },
                        { info1: 'price', info2: '是', info3: 'Decimal', info4: '月票单价，单位：元' },
                        { info1: 'amountMoney', info2: '是', info3: 'Decimal', info4: '总金额，单位：元' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/getMonthTicketConfigDetail.vue